import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["close"];

  async connect() {
    this.closeTargets.forEach((target) => {
      target.addEventListener("click", (e) => {
        e.preventDefault();
        this.element.close();
      });
    });
  }
}
